import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'motion/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css/pagination';

const testimonialsData = [
  {
    "id": 1,
    "name": "Sarah Johnson",
    "position": "CEO, TechStart Inc.",
    "image": "user1.jpg",
    "testimonial": "The creative solutions provided by Sivoci transformed our brand identity and market presence. Their strategic approach and attention to detail exceeded our expectations.",
    "rating": 5
  },
  {
    "id": 2,
    "name": "Michael Chen",
    "position": "Marketing Director, Global Retail",
    "image": "user2.jpg",
    "testimonial": "Working with Sivoci on our rebranding was a game-changer. Their creative team understood our vision and delivered a comprehensive strategy that resonated with our audience.",
    "rating": 4.5
  },
  {
    "id": 3,
    "name": "Emily Rodriguez",
    "position": "Founder, Design Collective",
    "image": "user3.jpg",
    "testimonial": "The innovative approach and creative solutions provided by Sivoci helped us stand out in a competitive market. Their team's expertise and dedication were invaluable to our success.",
    "rating": 5
  }
]

const Testimonial = () => {
  const getUserImage = (imageName) => {
    return require(`../../assets/user_images/${imageName}`)
  }

  const renderStars = (rating) => {
    const stars = []
    const fullStars = Math.floor(rating)
    const hasHalfStar = rating % 1 !== 0

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={`full-${i}`} className="ri-star-fill"></i>)
    }

    if (hasHalfStar) {
      stars.push(<i key="half" className="ri-star-half-fill"></i>)
    }

    return stars
  }

  return (
    <section className="testimonials-section py-5 bg-light">
      <Container className="py-5">
        <div className="service-heading mb-3">
          <motion.h6 className="underline-after text-center position-relative z-0"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="position-relative z-1 bg-white text-primary px-3">TESTIMONIALS</span>
          </motion.h6>
          <motion.h2 className="d-block text-gradiant text-center fw-semibold display-5"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            What Our Clients Say
          </motion.h2>
        </div>

        <Row>
          <Col xs={12}>
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={24}
              slidesPerView={1}
              pagination={{ clickable: true }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              breakpoints={{
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 }
              }}
              className="testimonialSwiper pb-5"
            >
              {testimonialsData.map((testimonial) => (
                <SwiperSlide key={testimonial.id}>
                  <motion.div
                    whileHover={{ y: -10, transition: { duration: 0.3 } }}
                  >
                    <Card className="border-0 shadow-sm p-4 rounded-4 h-100">
                      <div className="d-flex align-items-center mb-4">
                        <motion.img src={getUserImage(testimonial.image)} alt={testimonial.name} className="rounded-circle"
                          width="60" height="60" whileHover={{ scale: 1.1, rotate: 5 }} transition={{ duration: 0.3 }}
                        />
                        <div className="ms-3">
                          <h5 className="mb-0">{testimonial.name}</h5>
                          <p className="mb-0 text-muted">{testimonial.position}</p>
                        </div>
                      </div>
                      <p className="mb-3">{testimonial.testimonial}</p>
                      <div className="text-warning">
                        {renderStars(testimonial.rating)}
                      </div>
                    </Card>
                  </motion.div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Testimonial;
